import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { YesNoQuestion } from '../../../../core/models/survey/yes-no-question.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject, ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-yes-no-question',
  templateUrl: './yes-no-question.component.html',
  styleUrls: ['./yes-no-question.component.scss'],
})
export class YesNoQuestionComponent implements OnInit {


  @Output() pickedValue = new EventEmitter<boolean>();

  @Input() question: YesNoQuestion;

  value: string = 'yes';

  constructor() { }

  ngOnInit() {
    this.pickedValue.emit( 'yes' === this.value );    
  }

  changedValue(newValue) {
    this.pickedValue.emit( 'yes' === this.value );    
  }


}
